export default function detectBrowser() {
  if (typeof window === "undefined") {
    return undefined;
  }
  if ("ActiveXObject" in window) {
    return "ie";
  }
  if (
    window.opr &&
    Object.prototype.toString.call(window.opr) === "[object Opera]"
  ) {
    return "opera";
  }
  if ("chrome" in window) {
    return "chrome";
  }
  if (
    /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ||
    (window.Apple && window.Apple.ejecta)
  ) {
    return "safari";
  }
  if (typeof InstallTrigger !== "undefined") {
    return "firefox";
  }
  if (/Edge\//.test(navigator.userAgent)) {
    return "edge";
  }
  return undefined;
}
